module.exports = __webpack_public_path__ + "static/media/bankid-chip.65ca4595.svg";